//////////////////////////////////////////////////////////////////
//
//  文字ハイライトアニメ
//
//////////////////////////////////////////////////////////////////

(function (document) {
  const markers = [...document.querySelectorAll('mark')];
  
  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.style.animationPlayState = 'running';
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.8
  });
  
  markers.forEach(mark => {
    observer.observe(mark);
  });
})(document);


//////////////////////////////////////////////////////////////////
//
//  ページメニューボタン表示 
//
//////////////////////////////////////////////////////////////////

$(document).ready(function() {
	var flag = false;
	var pagetop = $('.btn_pagenavi_block, .btn_pagenavi_block2');
	$(window).scroll(function () {
		scrollHeight = $(document).height();
		scrollPosition = $(window).height() + $(window).scrollTop();
		if (
			(scrollHeight - scrollPosition) / scrollHeight <= 0.3) {
			//スクロールの位置が下部30%の範囲に来た場合
			pagetop.addClass("slidedown");
			pagetop.removeClass("slideup");
		} else {
			//それ以外のスクロールの位置の場合
			pagetop.removeClass("slidedown");
			pagetop.addClass("slideup");
		}
	});
});
/*$(function () {
	if ($(".btn_pagenavi_block").length) {
		var target = $(".btn_pagenavi_block");//ここに追尾したい要素名を記載
		var footer = $(".l_main_right")//ストップさせる
		var targetHeight = target.outerHeight(true);
		var targetTop = target.offset().top;

		$(window).scroll(function () {
			var scrollTop = $(this).scrollTop();
			if (scrollTop > targetTop) {
				// 動的にコンテンツが追加されてもいいように、常に計算する
				var footerTop = footer.offset().top;

				if (scrollTop + targetHeight > footerTop) {
					customTopPosition = footerTop - (scrollTop + targetHeight)
					target.addClass("slideup");
				} else {
					target.addClass("slidedown");
					target.removeClass("slideup");
				}
			} else {
				target.removeClass("slidedown");
				target.addClass("slideup");
			}
		});
	}
});*/


$(function () {
  setTimeout(function(){
    // メニューを半分隠す
    $(".dl-menu").css("right", "-150px");
  }, 2000);
  $(".dl-menu").hover(function() {
    // マウスが重なったときにメニューを表示する
    $(this).css("right", "0");
  });
  $(".dl-menu").mouseleave(function() {
    // マウスが離れたときにメニューを非表示にする
    $(this).css("right", "-150px");
  });
});
/*$(function () {
	$(".menu-float-hover").hover(function() {
		// マウスが重なったときにクラスを追加する
		//$('.menu-float-btn-list').addClass("show");
		//$('.menu-float-btn-list').removeClass("hide");

		$('.menu-float-btn-list').slideDown('fast');
	}, function() {
		// マウスが離れたときにクラスを削除する
		$('.menu-float-btn-list').slideUp('fast');
	});
});*/

//////////////////////////////////////////////////////////////////
//
//  ヘッダー/フッタースクロール
//  ページトップ
//
//////////////////////////////////////////////////////////////////

/*(function($) {
	$(function() {
		var $header = $('.header');
    //var $slider = $('.slider');
		$(window).scroll(function() {
		if ($(window).scrollTop() > 50) {
			$header.addClass('fixed');
      //$slider.addClass('fixed');
			} else {
				$header.removeClass('fixed');
        //$slider.removeClass('fixed');
			}
		});
	});
})(jQuery);

(function($) {
	$(function() {
		var $header = $('.header3');
    //var $slider = $('.slider');
		$(window).scroll(function() {
		if ($(window).scrollTop() > 500) {
			$header.addClass('fixed');
      //$slider.addClass('fixed');
			} else {
				$header.removeClass('fixed');
        //$slider.removeClass('fixed');
			}
		});
	});
})(jQuery);*/


// ページが読み込まれたらすぐ
/*$(window).on('load', function () {
	const header = $('.header');
	const homeHeader = $('.home_index').find('.header');
	if(homeHeader){
		homeHeader.hide();
	} else if (!homeHeader){
		homeHeader.show();
	} else {
		if(header.css('display','none')) {
			header.show();
		}
	}
	if(header){
		header.addClass('scrollin');
	} else {
		header.removeClass('scrollin');
	}
});*/

/*$(window).on('load', function () {
	const header = $('.header');
	const breadcrumb = $('.header-breadcrumb');
	const homeHeader = $('.home_index').find('.header');
	breadcrumb.hide();
	if(homeHeader){
		header.addClass('scrollin');
		header.addClass('fixed');
	} else {
		header.addClass('scrollin');
		header.addClass('fixed');
	}
});*/

/*$(window).on('load', function () {
	const breadcrumb = $('.header-breadcrumb');
	const homeHeader = $('.home_index').find('.header');
	breadcrumb.hide();
	if(homeHeader){
		breadcrumb.hide();
	}
});*/

// 画面をスクロールをしたら
/*$(window).scroll(function() {
	const header = $('.header');
	const breadcrumb = $('.header-breadcrumb');
	const logo = $('.gnavi-logo');
	const scroll = $(window).scrollTop();
	if(scroll > 50){//上から50pxスクロールされたら
		//logo.fadeIn();
		//header.addClass('fixed');
		breadcrumb.addClass('fixed');
	} else {
		//header.removeClass('fixed');
		breadcrumb.removeClass('fixed');
	}
});*/

// ヘッダースクロール

/*$(function(){
	$(window).scroll(function () {
		const header = $('.header');
		const breadcrumb = $('.header-bottom');
		const scroll = $(window).scrollTop();
		const width = $(window).width();

		if(width > 768 && scroll > 50){
			breadcrumb.addClass('fixed');
		} else {
			breadcrumb.removeClass('fixed');
		}
		
		if(width > 1024 && scroll > 1400){
			header.addClass('fixed');
			header.addClass('dw');
		} else if (width > 768 && scroll >! 600) {
			header.removeClass('dw');
			header.addClass('up');
		} else {
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');
		}
	});
});*/

$(function(){
  var pos1 = 0;
  var header = $('.header');
	var width1 = $(window).width();

	var pageheader = $('.pageheader, .pageheader2, .pagemenu');
  
  $(window).on('scroll', function(){
		
    if(width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() !== 0){
      //上スクロール時の処理
      header.addClass('fixed');
			header.addClass('dw');
			header.removeClass('up');

			// header挙動時のページメニュー動作
			pageheader.addClass('dw');
			pageheader.removeClass('up');

		} else if (width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() == 0) {
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');

			pageheader.removeClass('dw');
			//pageheader.removeClass('up');

		} else if (width1 > 1023 && $(this).scrollTop() <! pos1 && $(this).scrollTop() == 0) {
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');

			pageheader.removeClass('dw');
			pageheader.removeClass('up');

    }else{
      //下スクロール時の処理
			header.removeClass('dw');
			header.addClass('up');

			// header挙動時のページメニュー動作
			pageheader.removeClass('dw');
			pageheader.addClass('up');
    }
    pos1 = $(this).scrollTop();

		if(width1 < 1023){
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');
    }
  });
});

$(function(){
	$(window).on('scroll', function(){

		const breadcrumb = $('.header-bottom');
		const scrollbc = $(window).scrollTop();
		const width = $(window).width();

		if(width > 768 && scrollbc > 50){
			breadcrumb.addClass('fixed');
		} else {
			breadcrumb.removeClass('fixed');
		}
  });
});

$(function(){
	$(window).on('scroll', function(){

		const menuLeft = $('.menu-appfilds02-lft');
		const menuRight = $('.menu-appfilds02-rgt');
		const scrollMenu = $(window).scrollTop();

		if(scrollMenu >= 4500 && scrollMenu <= 9500 ){
			menuLeft.css("left", "5px");
		} else if (scrollMenu < 4500 || scrollMenu > 9500) {
			menuLeft.css("left", "-150px");
		} else {
			menuLeft.css("left", "-150px");
		}

		if(scrollMenu >= 9500 && scrollMenu <= 15000 ){
			menuRight.css("right", "5px");
		} else if (scrollMenu < 9500 || scrollMenu > 15000) {
			menuRight.css("right", "-150px");
		} else {
			menuRight.css("right", "-150px");
		}
  });
});

$(function () {
  setTimeout(function(){
    // メニューを半分隠す
    $(".dl-menu").css("right", "-150px");
  }, 2000);
  $(".dl-menu").hover(function() {
    // マウスが重なったときにメニューを表示する
    $(this).css("right", "0");
  });
  $(".dl-menu").mouseleave(function() {
    // マウスが離れたときにメニューを非表示にする
    $(this).css("right", "-150px");
  });
});

// お問い合わせボタン + フッタースクロール

$(function(){
  var pos = 0;
  //var contactSensor = $('.btn-contact-sensor');
	var footerMenu = $('.footer-menu');
	var pagetop = $('.footer-menu-pagetop');
	var width2 = $(window).width();

	//var menufloatbtm = $('.menu-float-btm');

	if(width2 > 1024){
		$(window).on('scroll', function(){
			if($(this).scrollTop() < pos && $(this).scrollTop() !== 0 ){
				//上にスクロール時ボタン挙動
				//contactSensor.removeClass('dw');
				//contactSensor.addClass('up');
				footerMenu.removeClass('up');
				footerMenu.addClass('dw');

				//menufloatbtm.removeClass('up');
				//menufloatbtm.addClass('dw');

			}else{
				//下にスクロール時ボタン挙動
				//contactSensor.removeClass('up');
				//contactSensor.addClass('dw');
				footerMenu.removeClass('dw');
				footerMenu.addClass('up');

				//menufloatbtm.removeClass('dw');
				//menufloatbtm.addClass('up');
			}
			pos = $(this).scrollTop();
		});
	}else{
		$(window).on('scroll', function(){
			if($(this).scrollTop() < pos && $(this).scrollTop() !== 0 ){
				//上にスクロール時ボタン挙動
				//contactSensor.removeClass('dw');
				//contactSensor.addClass('up');
				footerMenu.removeClass('dw');
				footerMenu.addClass('up');

				//menufloatbtm.removeClass('dw');
				//menufloatbtm.addClass('up');
			}else{
				//下にスクロール時ボタン挙動
				//contactSensor.removeClass('up');
				//contactSensor.addClass('dw');
				footerMenu.removeClass('up');
				footerMenu.addClass('dw');

				//menufloatbtm.removeClass('up');
				//menufloatbtm.addClass('dw');
			}
			pos = $(this).scrollTop();
		});
	}

	/*pagetop.click(function () {
		$('body, html').animate({ scrollTop: 0 }, 700);
	});*/
});

$(function(){
  //var btn = $('.button');
	var btn = $('.btn-contact-sensor');
  var timer;
	var pos2 = 0;
	var width3 = $(window).width();

	var menufloatbtm = $('.menu-float-btm');
  
	if(width3 > 1024){
		$(window).scroll(function() {
			//スクロール開始するとボタンを非表示
			//btn.removeClass('is-active');
			btn.removeClass('up');
			btn.addClass('dw');

			menufloatbtm.removeClass('up');
			menufloatbtm.addClass('dw');
			
			//スクロール中はイベントの発火をキャンセルする
			clearTimeout(timer);
			
			//スクロールが停止して0.2秒後にイベントを発火する
			timer = setTimeout(function() {
				//スクロール位置を判定してページ上部のときはボタンを非表示にする
				if($(this).scrollTop()) {
					//btn.addClass('is-active');
					btn.removeClass('dw');
					btn.addClass('up');

					menufloatbtm.removeClass('dw');
					menufloatbtm.addClass('up');
				}else{
					//btn.removeClass('is-active');
					btn.removeClass('up');
					btn.addClass('dw');

					menufloatbtm.removeClass('up');
					menufloatbtm.addClass('dw');
				}
			}, 200);
		});
	}else{
		$(window).on('scroll', function(){
			btn.removeClass('up');
			btn.addClass('dw');

			menufloatbtm.removeClass('up');
			menufloatbtm.addClass('dw');
			clearTimeout(timer);
			timer = setTimeout(function() {
				if($(this).scrollTop() < pos2 && $(this).scrollTop() !== 0 ){
					//上にスクロール時ボタン挙動
					btn.removeClass('up');
					btn.addClass('dw');

					menufloatbtm.removeClass('up');
					menufloatbtm.addClass('dw');
				}else{
					//下にスクロール時ボタン挙動
					btn.removeClass('dw');
					btn.addClass('up');

					menufloatbtm.removeClass('dw');
					menufloatbtm.addClass('up');
				}
				pos2 = $(this).scrollTop();
			}, 200);
		});
	}
  
  //ボタンクリックでトップへ戻る
  //btn.on('click',function () {
  //  $('body,html').animate({
  //    scrollTop: 0
  //  });
  //});
});

/*$(function(){
  //var btn = $('.button');
	var btn = $('.btn-contact-sensor');
  var timer;
  
  $(window).scroll(function() {
    //スクロール開始するとボタンを非表示
    //btn.removeClass('is-active');
		btn.removeClass('dw');
		btn.addClass('up');
    
    //スクロール中はイベントの発火をキャンセルする
    clearTimeout(timer);
    
    //スクロールが停止して0.2秒後にイベントを発火する
    timer = setTimeout(function() {
      //スクロール位置を判定してページ上部のときはボタンを非表示にする
      if($(this).scrollTop()) {
        //btn.addClass('is-active');
				btn.removeClass('up');
				btn.addClass('dw');
      }else{
        //btn.removeClass('is-active');
				btn.removeClass('dw');
				btn.addClass('up');
      }
    }, 1000);
  });
  
  //ボタンクリックでトップへ戻る
  //btn.on('click',function () {
  //  $('body,html').animate({
  //    scrollTop: 0
  //  });
  //});
});*/

// ページ内スクロール

/*$(function(){
  // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
  $('a[href^="#"]').click(function(){
    // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
    var adjust = -80;
    // スクロールの速度（ミリ秒）
    var speed = 400;
    // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
    var href= $(this).attr("href");
    // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
    var position = target.offset().top + adjust;
    // スムーススクロール linear（等速） or swing（変速）
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});*/

/*$(document).ready(function() {
	var flag = false;
	var pagetop = $('.footer-menu');
	$(window).scroll(function () {
		if ($(this).scrollTop() > 300) {
			if (flag == false) {
				flag = true;
				pagetop.stop().animate({
					'bottom': '-2px'
				}, 200);
				//pagetop.stop().animate(200).addClass('pagetop_position');
			}
		} else {
			if (flag) {
				flag = false;
				pagetop.stop().animate({
					'bottom': '-125px'
				}, 200);
				//pagetop.stop().animate(200).removeClass('pagetop_position');
			}
		}
	});
	pagetop.click(function () {
		$('body, html').animate({ scrollTop: 0 }, 700);
		return false;
	});
});*/


////////////////////////////////////////////////////////
//
//  anime-trigger
//
////////////////////////////////////////////////////////


window.onload = function() {
  scroll_effect();
  //fadeInEffect();

  $(window).scroll(function(){
   scroll_effect();
   //fadeInEffect();
  });

  function scroll_effect(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    // anime trigger
    $('.fx').each(function(i){
      var elemPos = $(this).offset().top;
      var target = this;
      if (scroll > elemPos - windowHeight){
        //$(target).addClass("scrollin");
        setTimeout(function () {
          $(target).addClass("scrollin");
        }, 2 * i );
      /*}else{
        $(this).removeClass('scrollin');*/
      }
    });
    $('.sldbar').each(function(i){
      var elemPos = $(this).offset().top;
      var target = this;
      if (scroll > elemPos - windowHeight){
        //setTimeout(function () {
        //  $(target).addClass("scrollin");
        //}, 100 * i );
        //}else{
        //$(this).removeClass('scrollin');
        let delay = 100;
        $(this).delay(i * delay).queue(function(next){
          $(this).addClass('scrollin');
          next();
        })
      }
    });
  }
};

//////////////////////////////////////////////////////////////////
//
//  バナーポップ
//
//////////////////////////////////////////////////////////////////

/*(function($) {
  $(function () {
      var display = function () {
      if ($(this).scrollTop() > 150) { //scroll量
              $(".Bnr").fadeOut();
          } else {
              $(".Bnr").fadeIn();
          }
      };
      $(window).on("scroll", display);
      //click
      $(".Bnr p.close a").click(function(){
      $(".Bnr").fadeOut();
      $(window).off("scroll", display);
      });
  });*/

  $(function() {
    var slide = $('.slide_banner');
    var contents = $('.slide_banner_contents');
    //開くボタン
    var openBtn = $('.slide_banner_btn img');
    var btnOpenFlag = false;
    var openFlag = false;
    var panelSwitch = function() {
			//閉じる
      if (openFlag == true ) {
				slide.stop().animate({'width' : '100%','height' : '70px'}, 500); 
				openBtn.show();		//開くボタンにする
				$.cookie("open-panel" , "open" , { path: "/" });
      }
      //開く
      else if (openFlag == false) {
				slide.stop().animate({'width' : '100%','height' : '200px'}, 500); 
				openBtn.hide();		//閉じるボタンにする
				$.removeCookie("open-panel" , { path: "/" });
      }
    };
    //開くボタンクリックしたら
    $('.slide_banner_btn').click(function(){
      panelSwitch();
      openFlag = !openFlag;
			btnOpenFlag = true;
		});

    //画面下位置を取得
    //var bottomPos = $(document).height() - $(window).height() - 500;
    $(window).scroll(function () {
      if (!btnOpenFlag) {
        if ($(this).scrollTop() >= 150) {
          if (openFlag == false) {
            panelSwitch();
						openFlag = true;
						$.removeCookie("open-panel" , { path: "/" });
          }
        } else {
          if (openFlag) {
            panelSwitch();
						openFlag = false;
						$.cookie("open-panel" , "open" , { path: "/" });
          }
        }
      }
    });
	});
	/*$(function() {
    var winWidth = $('body').outerWidth(true);
    var footer = $('.footer2');
    var slide = $('.slide');
    //画面下位置を取得
    var bottomPos = $(document).height() - $(window).height() -500;
    var showFlug = false;
 
    // ウィンドウより小さかったら開く
    panelOpen();
    //slideを画面右外へ配置
    $('.slide').css('margin-left', winWidth+'px');
    $(window).scroll(function () {
        panelOpen();
    });
    //閉じるボタン
    $('.close').click(function(){
        footer.hide();
    });
    //ウィンドウリサイズしたらwidth変更
    $(window).resize(function(){
        winWidth = $('body').outerWidth(true);
        bottomPos = $(document).height() - $(window).height() - 1000;
    });
 
    function panelOpen() {
        if ($(this).scrollTop() < bottomPos) {
            if (showFlug == false) {
                showFlug = true;
                slide.stop().animate({'marginLeft' : '0px'}, 200);
            }
        } else {
            if (showFlug) {
                showFlug = false;
                slide.stop().animate({'marginLeft' : winWidth+'px'}, 200);
            }
        }
    }
});*/
$(function(){
  if ($.cookie('open-panel') == 'open') {
    $('.panelbox_inner').hide();
  } else {
    $('.panelbox_inner').show();
  }
  $('.btn_panelbox').click(function() {
    if ($.cookie('open-panel')) {
      $('.panelbox_inner').slideDown('fast');
      $.removeCookie('open-panel', { path: '/' });
    } else {
      $('.panelbox_inner').slideUp('fast');
      $.cookie('open-panel', 'open', { expires: 1, path: '/' });
    }
    return false;
  });
});